<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Edit Node Group</h4>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
</div>

<table class="table nodeGroupTable text-grey"
       style="text-align: left; margin-bottom: 0px">
  <tbody class="tableBody">
    <tr *ngIf="assigned != null">
      <td>
        Assigned Node Groups
      </td>
      <td>
        <span>{{ assigned || "No Node Group Assigned"}}</span>
      </td>
     </tr>
  <tr>
    <td>
      Available Node Groups
    </td>
    <td>
      <div *ngFor="let item of nodeGroups">
        <input type="checkbox"
               (change)="onChange($event.target.checked, item)"
               [checked]="checked(item)">
        {{item || "No Node Group Available"}}
      </div>
    </td>
  </tr>
  </tbody>
</table>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="save()">Save</button>
</div>
